import { PatientAssessmentLink } from 'lib/documents/patient-assessment/patient-assessment-link';
import { httpsCallableWrapper, onRequestWrapper } from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';
import { deserialiseAPIObject } from '../parseAPIJSON';

export abstract class AssessmentLinkAPI {
  /**
   * Create a new Assessment Link for a Patient
   * @param patientId
   * @returns
   */
  public static create = (args: { patientId: string }) =>
    httpsCallableWrapper<{ patientId: string }, PatientAssessmentLink['id']>(
      API_ROUTE_CONFIG.patient.assessmentLink.create
    )(args);

  /**
   * Generate an Assessment Link token
   * @param assessmentLinkId
   * @returns
   */
  public static generateToken = (args: { assessmentLinkId: string }) =>
    httpsCallableWrapper<{ id: string }, string>(
      API_ROUTE_CONFIG.patient.assessmentLink.generateToken
    )({ id: args.assessmentLinkId });

  public static list = (args: { patientId: string }) =>
    httpsCallableWrapper<{ patientId: string }, PatientAssessmentLink[]>(
      API_ROUTE_CONFIG.patient.assessmentLink.getAllForPatient
    )(args).then(_ => deserialiseAPIObject(_.data));

  /**
   * Delete an assessment link
   * @param args
   * @returns
   */
  public static deactivate = (args: { assessmentLinkId: string }) =>
    httpsCallableWrapper<{ id: string }, string>(
      API_ROUTE_CONFIG.patient.assessmentLink.deactivate
    )({ id: args.assessmentLinkId });

  /**
   * Use an assessment link token to sign in
   */
  public static consumeToken = (args: { token: string }) =>
    onRequestWrapper<{ token: string }, { signInToken: string }>(
      API_ROUTE_CONFIG.patient.assessmentLink.consumeToken
    )({ token: args.token });
}
